<div class="ifp-contractor-box-wrapper">
  <div class="contractor-heading">
    {{ 'onboarding.sellMA.title' | translate }}
  </div>

  <div class="contractor-desc">
    {{ 'onboarding.sellMA.description' | translate }}
  </div>

  <form [formGroup]="ifpForm" class="ifp-box-form">
    <div class="existingOpportunity">
      <label>{{ 'onboarding.sellMA.ctLicense' | translate }}</label>

      <mat-radio-group
        aria-label="Select an option"
        formControlName="licensedInCt"
        (change)="isLicensedInCt($event.value)"
      >
        <mat-radio-button [value]="true"> Yes </mat-radio-button>
        <mat-radio-button [value]="false"> No</mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="State">
      <label>{{ 'onboarding.sellMA.producerState' | translate }}</label>

      <mat-form-field appearance="outline" class="input-work-state">
        <mat-select
          placeholder="Select"
          disableOptionCentering
          matInput
          [ngModel]
          state="state"
          formControlName="state"
        >
          <mat-option [value]="'global.select' | translate" [disabled]="true">
            {{ 'global.select' | translate }}
          </mat-option>

          <mat-option *ngFor="let country of countries" [value]="country">
            {{ country }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="ResidenState">
      <label>{{ 'onboarding.sellMA.licensedStates' | translate }}</label>

      <mat-form-field appearance="outline">
        <mat-select
          placeholder="Select"
          panelClass="comp-multi-select-panel"
          formControlName="residentStates"
          [ngModel]
          residentStates="residentStates"
          multiple
          required
        >
          <mat-option
            *ngFor="let country of countries"
            [value]="country"
            class="countryOptions"
          >
            {{ country }}
          </mat-option>
        </mat-select>

        <mat-error>
          <div
            class="input-error"
            *ngIf="
              ifpForm?.get('residentStates')?.hasError('required') &&
              ifpForm.get('residentStates')?.pristine
            "
          >
            <cigna-icon
              type="exclamation-triangle"
              class="alert-icon"
            ></cigna-icon>
            {{ 'global.required' | translate }}
          </div>
        </mat-error>
      </mat-form-field>
    </div>
  </form>

  <div class="btns">
    <button
      type="submit"
      mat-raised-button
      cg-mat-btn-type="primary"
      class="ls-button-fill"
      data-test-id="btn-submit"
      [disabled]="ifpForm.invalid"
      (click)="onContinue()"
    >
      {{ 'global.continue' | translate }}
    </button>
    <span
      mat-button
      class="cancel-btn"
      cg-mat-btn-type="secondary"
      data-test-id="btn-cancel"
      (click)="onCancelClicked()"
    >
      {{ 'global.cancel' | translate }}
    </span>
  </div>
</div>
